

import { Component, Vue, Prop ,Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getTaskDiyEvaluateList } from '@/api/orderTask';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';


@Component({
  name: 'EvaluateInfo',
  components: {},
})
export default class extends Vue {

  @Prop({
    type: Object,
    default: () => ({
      order: {},
      order_service: {}
    })
  })orderDetail!:any;

  private tableDataOrderEvaluation:any=[];
  private tableDataOrderServiceEvaluation:any=[];
  private isModifyEvaluate:boolean=false;

  created() {
    this.isModifyEvaluate=checkPermissionUseAndCompany(UserModule.getCompanyId,Type.OrderEvaluate)
    this.getEvaluateList();
  }

  @Watch("orderDetail.order_service.id")
  orderServiceChange(newV: string, oldV: string) {
    //服务单变更 更新评价
    this.getEvaluateList();
  }

  private getEvaluateList() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      order_id: this.orderDetail.order.id,
      order_service_id: this.orderDetail.order_service.id,
      service_company_id: this.orderDetail.order_service.servicer_company_id,
    };
    getTaskDiyEvaluateList(params).then((res: any) => {
      if (res.data) {
        this.tableDataOrderEvaluation = res.data.repair_diy_evaluate_list;
        this.tableDataOrderServiceEvaluation=res.data.service_diy_evaluate_list;
      }else{
        //无评价清空
        this.tableDataOrderEvaluation= [];
      }
    });
    
  }
  private editEvaluateHandle(){
    this.$emit('editEvaluateHandle',this.orderDetail)
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
